/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
export type PdpRespSeoLinks_viewer$ref = any;
export type PdpRespSeoLinks_viewer = {
    readonly isMoreWaysToBrowseEnabled: boolean | null;
    readonly " $refType": PdpRespSeoLinks_viewer$ref;
};



const node: ReaderFragment = ({
    "kind": "Fragment",
    "name": "PdpRespSeoLinks_viewer",
    "type": "Viewer",
    "metadata": null,
    "argumentDefinitions": [],
    "selections": [
        {
            "kind": "ScalarField",
            "alias": "isMoreWaysToBrowseEnabled",
            "name": "isEnabledByLocale",
            "args": [
                {
                    "kind": "Literal",
                    "name": "featureName",
                    "value": "MORE_WAYS_TO_BROWSE"
                }
            ],
            "storageKey": "isEnabledByLocale(featureName:\"MORE_WAYS_TO_BROWSE\")"
        }
    ]
} as any);
(node as any).hash = 'e46ceba8336e0a341bd5695245941c27';
export default node;
